







import {Component, Vue} from "vue-property-decorator";
import LadingForm from "../Form/index.vue";
import {LadingStore} from "@/modules/ladings/store";
Component.registerHooks([
    'beforeRouteLeave'
])
@Component({
    name: "LadingFormCreate",
    components: {LadingForm}
})
export default class extends Vue {
    beforeRouteLeave(to, from, next) {
        if (LadingStore.isDirtyForm) {
            const answer = window.confirm("Dữ liệu thay đổi chưa được lưu, bạn muốn chuyển trang ?");
            if (answer) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    }
}
